import Base from "../base";
import { PromptTemplate, DefaultPromptTemplate } from "./promptTemplate";

/** 計画書自動作成設定 */
export interface AiVnplanSetting extends Base {
  /** ID */
  id: number;
  /** プロンプトテンプレートID */
  prompt_template_id: number;
  /** AI選択機能利用フラグ 0:利用しない 1:利用する */
  is_use_ai_set: number;
  /** 最終更新者ID */
  editor_admin_id: number;
  /** インデックス情報 */
  index_settings: AiVnplanIndexSetting[];
}

export const DefaultAiVnplanSetting = (): AiVnplanSetting => ({
  id: 0,
  prompt_template_id: 0,
  is_use_ai_set: 0,
  editor_admin_id: 0,
  created_at: "",
  updated_at: "",
  deleted_at: "",
  index_settings: [],
});

/** 計画書自動作成インデックス設定 */
export interface AiVnplanIndexSetting extends Base {
  /** ID */
  id: number;
  /** 計画書自動作成設定 */
  ai_vnplan_setting_id: number;
  /** 年月指定種類 */
  yearmonth_type: number;
}

export const DefaultAiVnplanIndexSetting = (): AiVnplanIndexSetting => ({
  id: 0,
  ai_vnplan_setting_id: 0,
  yearmonth_type: 0,
  created_at: "",
  updated_at: "",
  deleted_at: "",
});

/** 看護計画書AI自動作成AI選択リスト */
export interface AiVnplanAiSet extends Base {
  /** ID */
  id: number;
  /** 表示名 */
  name: string;
  /** 説明文 */
  description: string;
  /** プロンプトテンプレートID */
  prompt_template_id: number;
  /** 表示フラグ 0:非表示 1:表示 */
  is_show: number;
  /** 有効フラグ 0:無効 1:有効 */
  is_valid: number;
  /** 表示順 */
  sort_no: number;
  /** プロンプトテンプレート */
  prompt_template: PromptTemplate;
}

export const DefaultAiVnplanAiSet = (): AiVnplanAiSet => ({
  id: 0,
  name: "",
  description: "",
  prompt_template_id: 0,
  is_show: 0,
  is_valid: 0,
  sort_no: 0,
  created_at: "",
  updated_at: "",
  deleted_at: "",
  prompt_template: DefaultPromptTemplate(),
});
